module.exports = __webpack_public_path__ + "img/JAOC_POP_SquidInkSauce_rectangular.447ae6dd.png";